import type { AdUnit } from '../../Entities/AdUnit.entity';
import { PATH_BASE } from '../Constants';
import { MPU_SIZE } from '../UnitSizes';

export const MPU = {
  path: `${PATH_BASE}/MPU1_UK`,
  sizes: [MPU_SIZE],
  defaultHeight: MPU_SIZE[1],
  maxWidth: 960,
  minHeight: 250,
  responsiveSizeMap: {
    1440: [],
    1280: [MPU_SIZE],
    1024: [MPU_SIZE],
    768: [MPU_SIZE],
    0: [MPU_SIZE],
  },
  useSizeMap: true,
  trackingData: {
    renderEvent: {
      name: 'UK_webapp_slot_render_ended',
      label: 'MPU 1 UK banner is loaded',
    },
    impressionEvent: {
      name: 'UK_webapp_impression_viewable',
      label: 'MPU 1 UK banner is loaded',
    },
  },
} as const satisfies AdUnit;
